// Angular Files
import { Pipe, PipeTransform } from '@angular/core';

// Named tileCasePipe just to ensure it doesn't conflict with Angular's titleCase pipe that doesn't work
@Pipe({
    name: 'titleCasePipe'
})
export class TitleCasePipe implements PipeTransform {

    /**
     * Transforms a string to title case.
     * @param str The string to transform
     * @param tagToWords If true, splits on hyphens instead of spaces
     * @param overrides Optional mapping for special cases. Keys can be:
     *   - Full string matches (checked first, returns value directly)
     *   - Word-level matches (applied during processing)
     */
    transform(str: string, tagToWords: boolean = false, overrides?: { [key: string]: string }) {
        if(str) {
            // Check for full string override first
            if (overrides && overrides[str]) {
                return overrides[str];
            }

            let strArr;
            if(tagToWords)
                strArr = str.split("-");
            else
                strArr = str.split(" ");

            for(let i = 0; i < strArr.length; i++) {
                let word = strArr[i];
                // Check for word-level override
                if (overrides && overrides[word]) {
                    strArr[i] = overrides[word];
                } else {
                    word = word[0].toLocaleUpperCase() + word.slice(1);
                    strArr[i] = word;
                }
            }
            return strArr.join(" ");
        }
    }

}
